import { UserResponseDto } from "~/gen/api/user";

export const getUserProfile = (state:any) => (state?.admin?.resources?.profile?.data?.edit) as (UserResponseDto | undefined)

